import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addKeyToFineRegNoti, getFlagNotiFineReg } from '../../../store/actions/notificationAction';
import { login } from '../../../store/actions/authenAction';
import PassAuthenToVerify from "../../../components/authentication/verify/PassAuthenToVerify";

class PassAuthenToVerifyPage extends Component {
  constructor(props) {
      super(props)
      this.state = {}
    }

  render() {
    console.log('render..')
    return (
      <PassAuthenToVerify {...this.props} />
    )
  }
}

export default connect(
  store => ({
    setting: store.theme,
  }),
  {
    login,
    addKeyToFineRegNoti,
    getFlagNotiFineReg,
  },
)(PassAuthenToVerifyPage)
